import { ColDef } from "ag-grid-community";
import moment from "moment";
import { centsToUsd, formatCount } from "./format";

// Shared ag-grid column factories for the detail-list pages (Transaction, Order Items, Audit).
export const moneyCol = (field: string, headerName: string, extra: ColDef = {}): ColDef => ({
  field,
  headerName,
  type: "rightAligned",
  width: 130,
  valueFormatter: (p) => centsToUsd(p.value as number),
  ...extra,
});

export const intCol = (field: string, headerName: string, extra: ColDef = {}): ColDef => ({
  field,
  headerName,
  type: "rightAligned",
  width: 110,
  valueFormatter: (p) => formatCount(p.value as number),
  ...extra,
});

export const textCol = (field: string, headerName: string, extra: ColDef = {}): ColDef => ({
  field,
  headerName,
  width: 140,
  ...extra,
});

export const dateTimeCol = (field: string, headerName: string, extra: ColDef = {}): ColDef => ({
  field,
  headerName,
  width: 170,
  valueFormatter: (p) => (p.value ? moment.utc(p.value as string).format("YYYY-MM-DD HH:mm") : ""),
  ...extra,
});

// Green "IN" / red "OUT" inclusion column (excluded rows are shaded by DetailTable's getRowStyle).
export const inclusionCol = (): ColDef => ({
  headerName: "In/Out",
  field: "included",
  pinned: "left",
  width: 84,
  valueGetter: (p) => ((p.data as { included?: boolean } | undefined)?.included ? "IN" : "OUT"),
  cellStyle: (p) => ({ fontWeight: 700, color: p.value === "IN" ? "#15803d" : "#b91c1c" }),
});
